import React from 'react';
import PropTypes from 'prop-types';
import { VertContainer } from '@vertem-core/vertice-ds';

const Container = ({ children }) => {
  return (
    <VertContainer className="VertContainer">
      { children }
    </VertContainer>
  );
};

Container.propTypes = {
  children: PropTypes.node
};

export default Container;
